import React from 'react';
import { format, subDays } from 'date-fns';

import { DateInput, DatePicker, FormField, FormHelp, Label } from '@zillow/constellation-10';

import type { Section } from '../../../models';
import { DEMOLITION } from '../../../constants';
import YesAndNoExpansion from '../../../components/Widgets/YesAndNoExpansion';
import { DATE_PICKER_FORMAT } from '../../../constants/stringConstants';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function Demolition({ section, setSectionValues }: Props) {
  function onNoDemolition(): void {
    setSectionValues({
      [DEMOLITION.FIELD_NAME.IS_ENABLED]: false,
    });
  }

  function onYesDemolition(): void {
    setSectionValues({
      [DEMOLITION.FIELD_NAME.IS_ENABLED]: true,
    });
  }

  function onDemolitionDateChange(formattedDate: string): void {
    setSectionValues({
      [DEMOLITION.FIELD_NAME.DEMOLITION_DATE]: formattedDate,
    });
  }

  return (
    <FormField
      required
      label={<Label>Is the property scheduled to be demolished?</Label>}
      control={
        <YesAndNoExpansion
          yesHandler={onYesDemolition}
          noHandler={onNoDemolition}
          yesActive={section.getFieldValue(DEMOLITION.FIELD_NAME.IS_ENABLED)}
        >
          <FormField
            required
            label={<Label>What is the expected demolition date?</Label>}
            control={
              <DatePicker
                dateFormat={DATE_PICKER_FORMAT}
                value={section.getFieldValue(DEMOLITION.FIELD_NAME.DEMOLITION_DATE)}
                onValueChange={(value) => {
                  const formatted = typeof value === 'string' ? value : format(value, DATE_PICKER_FORMAT);
                  onDemolitionDateChange(formatted);
                }}
                minDate={subDays(new Date(), 1)}
                closeModalOnDateSelect
                input={<DateInput />}
              />
            }
            description={
              <FormHelp>
                On or after this date, active lease agreements will terminate for the property. You also must disclose
                to tenants if you have obtained a demolition permit for the property.
              </FormHelp>
            }
          />
        </YesAndNoExpansion>
      }
    />
  );
}

Demolition.description =
  'Date on which the property is to be demolished. There is no validation as this is not a legal requirement, just a disclosure.';

export default Demolition;
